import React from 'react';
import PropTypes from 'prop-types';

import TableSection from './section';

export default class TableHeader extends React.Component {
  static propTypes = {
    selected: PropTypes.bool,
    selectedColumnIndex: PropTypes.number
  }

  buildCellProps = (cell, rowIndex, columnIndex) => {
    return {
      // Header rows can not be selected
      inSelectedRow: false,

      // Header cells are only selected if the section and header is selected
      selected: this.props.selected && columnIndex === this.props.selectedColumnIndex
    };
  }

  render() {
    return (
      <TableSection
        {...this.props}
        buildCellProps={this.buildCellProps}
        section="headerRows"
      />
    );
  }
}
